import { useMutation, useQuery, useQueryClient } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useOldVersions = (config) => {
  return useQuery({
    ...config,
    queryKey: "system-versions-old-versions",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/system/versions/old-versions`,
        signal,
      }),
  });
};

export const useDeleteOldVersionsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/system/versions/old-versions`,
        method: "DELETE",
      }),
    onSuccess: (response) => {
      queryClient.setQueryData("system-versions-old-versions", response);
    },
  });
};
